import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import fetch from '../../../core/fetch';


class CandlesModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chosenCandle: null,
    }
  };

  lightCandles = () => {
    fetch(`${process.env.API_URL}/cmentarze/${this.props.prefix}/znicze/${this.props.graveId}`, {
      method: 'POST',
      body: JSON.stringify({"candle_type": this.state.chosenCandle}),
    	headers: {'Content-Type': 'application/json'}
    })
    .then(resp => {
      return resp.json();
    })
    .then(data => {
      this.props.onSuccess();
      this.props.onHide();
    })
    .catch(e => {
      console.info(e)
    })
  };

  render () {
    return (
      <Modal show={this.props.show} onHide={this.props.onHide}>
        <Modal.Header className="bg-default" closeButton>
          <Modal.Title>Zapalanie wirtualnego znicza</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>Wybierz znicz:</h4>{
            this.props.candlesTypes ? 
            Object.values(this.props.candlesTypes).map((image_src, i) =>
              (
                <img onClick={() => this.setState({chosenCandle: i})}
                  className={`${this.state.chosenCandle == i ? 'chosen-candle' : ''} candle`}
                  key={i}
                  src={image_src}
                  alt="Candle Icon"
                />
              )
            ) : null
          }
          <p>Wybrany znicz będzie widoczny przez 7 dni od momentu zapalenia.</p>
          <br /><br />
          <Button className="btn btn-default pull-right" onClick={this.lightCandles} disabled={this.state.chosenCandle == null}>Zapal znicz</Button>
          <Button className="btn btn-default pull-right" onClick={this.props.onHide}>Anuluj</Button>
          <br /><br />
        </Modal.Body>
      </Modal>
    );
  };
};

export default CandlesModal;


// WEBPACK FOOTER //
// src/components/Modals/CandlesModal/CandlesModal.js